import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getPlayersReport } from '../../../actions'

class PlayersReport extends Component {
  render () {
    const { players, report } = this.props
    const city = players && players[0].location.split(' ')[0]

    return [
      <div className='dashboard-teams-row' key='1'>
        <div className='cell-subject' >-----------------------</div>
      </div>,
      <div className='dashboard-teams-row' key='2'>
        <div className='cell-subject'>{city} Report</div>
        <div className='cell-tags cell-looking-for' />
        <div className='cell-team admin-tab-cell'>
          <button
            onClick={() => this.props.dispatch(getPlayersReport(city))}
            className='button button-sm'>Generate</button>
        </div>
        <div className='cell-team admin-tab-cell'>
          {report.generating && 'Working...'}
          {!report.generating && report.url !== '' && <a href={report.url} download>Download</a>}
        </div>
      </div>
    ]
  }
}

const mapStateToProps = (state) => {
  return {
    players: state.participants,
    report: state.reports.players
  }
}

export default connect(mapStateToProps)(PlayersReport)



// WEBPACK FOOTER //
// ./src/screens/administration/statistics/PlayersReport.js